import { render } from "./optional-filter-section-status.vue?vue&type=template&id=bb23732a&ts=true"
import script from "./optional-filter-section-status.ts?vue&type=script&lang=ts&external"
export * from "./optional-filter-section-status.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__